import { useContext, useState, useEffect } from "react";
import { fetchOrderSnippet } from "./Logics/OrderSnippet";
import {
  is_shop_admin,
  is_shop_manager,
  is_superuser,
  username,
  branch,
  socketurlbranch,
  socketurlsuper,
  is_franchise_admin,
  is_franchise_manager,
  is_franchise_staff,
  is_accountant_only,
  franchise,
  socketurlfranchise,
  version,
  version_updates,
  protocol,
  url,
  has_franchise_reach,
} from "../Functionalities/Config";
import { getToken } from "../Functionalities/Functions";
import { signOut } from "../Functionalities/signOut";
import profileImage from "../../src/Assets/images/profile_icon_header.png";
import ReactHowler from "react-howler";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import Lottie from "react-lottie";
import new_notification from "../../src/Assets/lottie/new_notification.json";
import notification from "../../src/Assets/lottie/notification.json";
import bell from "../../src/Assets/Sounds/bell.wav";

import { Offline, Online } from "react-detect-offline";
import { AppContext } from "../Functionalities/AppContext";
import FranchiseSwitcher from "./FranchiseSwitcher";
import { useScheduledReminders } from "../Functionalities/useScheduledReminders";

import Websocket from "react-websocket";

function Header(props) {
  const [data, setData] = useState({
    type: "",
    event: "",
    pending_count: 0,
    pending_data: [],
    notdelivered_count: 0,
    notdelivered_data: [],
    remaining_count: 0,
    remaining_data: [],
    ongoing_count: 0,
    ongoing_data: [],
    completed_count: 0,
    completed_data: [],
    alert_sound: "",
    scheduled_count: 0,
  });

  const { setNewOrders } = useContext(AppContext);
  const [scheduledCount, setScheduledCount] = useState(0);
  const syncScheduledOrders = useScheduledReminders();

  useEffect(() => {
    const pollOrderStats = async () => {
      try {
        const resData = await fetchOrderSnippet();
        if (!resData) return;

        setData((prev) => ({
          ...prev,
          pending_count:
            resData.pending_count !== undefined
              ? resData.pending_count
              : prev.pending_count,
          ongoing_count:
            resData.ongoing_count !== undefined
              ? resData.ongoing_count
              : prev.ongoing_count,
          alert_sound: resData.alert_sound || prev.alert_sound,
        }));
        if (resData.scheduled_count !== undefined) {
          setScheduledCount(resData.scheduled_count);
        }
        syncScheduledOrders(resData.scheduled_data);
      } catch (error) {
        console.error("Error polling order stats in header:", error);
      }
    };

    pollOrderStats();
  }, []);

  const checkNewOrders = (socketMsg) => {
    setNewOrders(true);
    let Orderdata = JSON.parse(socketMsg);
    syncScheduledOrders(Orderdata.scheduled_data);
    setData((prev) => {
      const updated = {
        ...prev,
        type: Orderdata.type ? Orderdata.type : "",
        event: Orderdata.event ? Orderdata.event : "",
        pending_count: Orderdata.pending_count ? Orderdata.pending_count : 0,
        pending_data: Orderdata.pending_data ? Orderdata.pending_data : [],
        notdelivered_count: Orderdata.notdelivered_count
          ? Orderdata.notdelivered_count
          : 0,
        notdelivered_data: Orderdata.notdelivered_data
          ? Orderdata.notdelivered_data
          : [],
        remaining_count: Orderdata.remaining_count
          ? Orderdata.remaining_count
          : 0,
        remaining_data: Orderdata.remaining_data
          ? Orderdata.remaining_data
          : [],
        ongoing_count: Orderdata.ongoing_count ? Orderdata.ongoing_count : 0,
        ongoing_data: Orderdata.ongoing_data ? Orderdata.ongoing_data : [],
        completed_count: Orderdata.completed_count
          ? Orderdata.completed_count
          : 0,
        completed_data: Orderdata.completed_data
          ? Orderdata.completed_data
          : [],
        alert_sound: Orderdata.alert_sound && Orderdata.alert_sound,
        scheduled_count: Orderdata.scheduled_count
          ? Orderdata.scheduled_count
          : 0,
      };

      return updated;
    });
  };

  const alertBox = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div>
            <div
              className="modal-content"
              style={{ minHeight: 200, maxHeight: 350, overflowY: "scroll" }}
            >
              <div className="modal-header">
                <h5 className="modal-title"> Unfinished Orders </h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => onClose()}
                >
                  {" "}
                  <span>×</span>{" "}
                </button>
              </div>

              <div className="col-xl-12 col-xxl-12">
                <div className="row">
                  <div className="col-xl-6">
                    <div className="card trending-menus">
                      <div className="card-header d-sm-flex d-block pb-0 border-0">
                        <div>
                          <h6 className="text-black fs-20"> Pending </h6>
                        </div>
                      </div>
                      <div className="card-body">
                        {data.pending_count > 0 ? (
                          data.pending_data.map((item, index) => {
                            return (
                              <div className="d-flex pb-3 mb-3 border-bottom tr-row align-items-center">
                                <div className="mr-auto pr-3">
                                  <a
                                    href={`/orderID/${item.id}`}
                                    className="text-black fs-14"
                                  >
                                    FDR{item.id}
                                  </a>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="d-flex pb-3 mb-3 border-bottom tr-row align-items-center">
                            <div className="mr-auto pr-3">
                              <p>No recent order message to show</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-6">
                    <div className="card trending-menus">
                      <div className="card-header d-sm-flex d-block pb-0 border-0">
                        <div>
                          <h6 className="text-black fs-20"> Not delivered </h6>
                        </div>
                      </div>
                      <div className="card-body">
                        {data.notdelivered_count > 0 ? (
                          data.notdelivered_data.map((item, index) => {
                            return (
                              <div className="d-flex pb-3 mb-3 border-bottom tr-row align-items-center">
                                <div className="mr-auto pr-3">
                                  <a
                                    href={`/orderID/${item.id}`}
                                    className="text-black fs-14"
                                  >
                                    FDR{item.id}
                                  </a>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="d-flex pb-3 mb-3 border-bottom tr-row align-items-center">
                            <div className="mr-auto pr-3">
                              <p> No recent order message to show </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    onClose();
                  }}
                >
                  {" "}
                  close{" "}
                </button>
              </div>
            </div>
          </div>
        );
      },
    });
  };

  return (
    <div>
      <div className="header">
        <div className="header-content">
          {protocol == "http://" && (
            <li className="nav-item ">
              <button
                className=""
                style={{
                  position: "absolute",
                  top: "0px",
                  right: "0px",
                  background: "#cf0000",
                  color: "rgb(255, 255, 255)",
                  width: "100%",
                  border: "none",
                  fontSize: "13px",
                }}
              >
                Debug server
              </button>
            </li>
          )}
          <nav className="navbar navbar-expand">
            <div className="collapse navbar-collapse justify-content-between">
              <div className="header-left">
                <div className="dashboard_bar">
                  {is_superuser && (
                    <Websocket
                      url={socketurlsuper}
                      onMessage={(data) => checkNewOrders(data)}
                    />
                  )}
                  {has_franchise_reach && (
                    <Websocket
                      url={`${socketurlfranchise}${franchise.id}/`}
                      onMessage={(data) => checkNewOrders(data)}
                    />
                  )}
                  {(is_shop_admin || is_shop_manager) && (
                    <Websocket
                      url={`${socketurlbranch}${branch[0].id}/`}
                      onMessage={(data) => checkNewOrders(data)}
                    />
                  )}

                  {props.name}
                  {props.name == "Dashboard" ? (
                    <span>
                      Hi {is_shop_manager && "Shop Manager ,"}
                      {is_shop_admin && "Shop Admin ,"}
                      {is_franchise_admin && "Franchise Admin ,"}
                      {is_franchise_manager && "Franchise Manager ,"}
                      {is_franchise_staff && "Franchise Staff ,"}
                      {is_superuser && "Foodoor Admin ,"}
                      Welcome to Foodoor Admin Panel!
                    </span>
                  ) : (
                    <span>{props.subHeading}</span>
                  )}
                </div>
              </div>
              <ul className="navbar-nav header-right">
                {is_superuser && (
                  <li className="nav-item franchise-switcher-item">
                    <FranchiseSwitcher />
                  </li>
                )}
                <li className="nav-item ">
                  <Online>
                    <i
                      className="fa fa-signal fa-2x text-green"
                      aria-hidden="true"
                    ></i>
                  </Online>
                  <Offline>
                    <i
                      className="fa fa-signal fa-2x text-red"
                      aria-hidden="true"
                    ></i>
                  </Offline>
                </li>
                <li className="nav-item dropdown header-profile">
                  {(!is_superuser ||
                    has_franchise_reach) && (
                    <span onClick={() => alertBox()}>
                      <Lottie
                        isClickToPauseDisabled
                        options={{
                          loop: true,
                          autoplay: true,
                          animationData:
                            data.pending_data.length > 0
                              ? new_notification
                              : notification,
                          rendererSettings: {
                            preserveAspectRatio: "xMidYMid slice",
                          },
                        }}
                        height={100}
                        width={100}
                      ></Lottie>
                    </span>
                  )}

                  <a
                    className="nav-link"
                    href="javascript:void(0)"
                    role="button"
                    data-toggle="dropdown"
                  >
                    {!is_superuser && (
                      <ReactHowler
                        src={bell}
                        playing={
                          data.pending_count > 0
                            ? data.alert_sound === "true"
                              ? true
                              : false
                            : false
                        }
                        loop={false}
                      />
                    )}

                    <img src={profileImage} width={20} alt />
                    <div className="header-info">
                      {!is_superuser && (
                        <strong class="text text-secondary mr-2">
                          {username && username}
                        </strong>
                      )}

                      <b class="text text-primary">
                        <strong
                          style={{ fontSize: is_superuser ? "14px" : "12px" }}
                        >
                          {is_shop_manager && "Manager"}
                          {is_superuser && "Foodoor Super Admin"}
                          {is_franchise_admin && "Franchise Admin"}
                          {is_franchise_manager && "Franchise Manager"}
                          {is_franchise_staff && "Franchise Staff"}
                          {is_accountant_only && "Accountant"}
                          {is_shop_admin && " Shop Admin"}
                        </strong>
                      </b>

                      {branch.length > 0 && branch[0].name && (
                        <span className="text-black">
                          <strong>
                            <i className="fa fa-cutlery">
                              &nbsp;{"  : "}
                              {branch.length > 0 ? branch[0].name : ""}
                            </i>
                          </strong>
                        </span>
                      )}
                      {
                        <span
                          className="text-black"
                          title={"Latest Updates : " + version_updates}
                        >
                          <>{`Version : ${version}`}</>
                        </span>
                      }
                    </div>
                  </a>
                  <div className="dropdown-menu dropdown-menu-right">
                    <a href="/profile" className="dropdown-item ai-icon">
                      <svg
                        id="icon-user1"
                        xmlns="http://www.w3.org/2000/svg"
                        className="text-primary"
                        width={18}
                        height={18}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx={12} cy={7} r={4} />
                      </svg>
                      <span className="ml-2">Profile </span>
                    </a>

                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        signOut();
                      }}
                      style={{ cursor: "pointer" }}
                      className="dropdown-item ai-icon"
                    >
                      <svg
                        id="icon-logout"
                        xmlns="http://www.w3.org/2000/svg"
                        className="text-danger"
                        width={18}
                        height={18}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                        <polyline points="16 17 21 12 16 7" />
                        <line x1={21} y1={12} x2={9} y2={12} />
                      </svg>
                      <span className="ml-2">Logout </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
}

export default Header;
